import { useEffect, useState } from "react";
import DashboardLayout from '../Layout/Index'
import OrderTable from '../components/tables/OrderTable'
import { FiSearch } from "react-icons/fi";
import { OrderDrawer } from "../Modals/OrderDrawer";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders } from "../redux/slices/orderSlice";
import { SelectDropDown } from "../components/SelectDropdown";

const Orders = () => {

  const itemsPerPage = 10;
  const dispatch = useDispatch();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1); 
  const [totalRecord, setTotalRecord] = useState(0); 
  const [paymentStatus, setPaymentStatus] = useState(null); 
  const [orderStatus, setOrderStatus] = useState(null); 

  const orders = useSelector((state) => state.order); 

  useEffect(() =>{
    dispatch(
      fetchOrders({
      searchText: searchTerm,
      pageSize: itemsPerPage,
      pageNumber: currentPage,
      paymentStatus: paymentStatus,
      orderStatus: orderStatus
    }))
  }, [dispatch, searchTerm, currentPage, paymentStatus, orderStatus]);


  const SelectedOption = [
    { label: "Pending", value: "1" },
    { label: "Initiated", value: "2" },
    { label: "Successful", value: "3" },
    { label: "Failed", value: "4" },
  ];

  useEffect(() => {
    if(orders){
      setTotalRecord(orders?.orders?.totalRecord);
    }
  },[orders]);

  const data = orders?.orders?.data;

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setIsDrawerOpen(true); 
  };

  const changePaymentStatus = (selectedOption) => {
    setPaymentStatus(selectedOption.value);
   };
  
  const changeOrderStatus = (selectedOption) => {
    setOrderStatus(selectedOption.value);
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <DashboardLayout>
      <div className="px-6 sm:px-8 pt-5 py-10 bg-white w-full mt-16">
        <div className="bg-white px-2 py-3">
          <h1 className="text-2xl font-bold text-[#FF0000] pb-2">Manage Orders Efficiently</h1>
          <h2 className="text-sm md:text-md font-medium text-[#0A0A0A]/80">
            Track, assign, and update orders in real-time to ensure smooth and timely deliveries for every customer.
          </h2>
        </div>
        <div className="flex flex-col lg:flex-row lg:items-center justify-between px-4 py-6 bg-white rounded-sm mb-5 md:shadow-[rgba(179, 179, 179, 0.25)]">
          <div className="relative">
            <input
              type="search"
              name="search"
              value={searchTerm}
              onChange={handleSearch}
              placeholder="Search by customer name"
              className="bg-[#F9F9F9] px-12 py-3 rounded-2xl w-[350px] ring-0 outline-none text-sm lg:text-md"
            />
            <FiSearch className="absolute left-4 top-3 text-lg text-[#A6A9B9]" />
          </div>
          <div className="flex items-center justify-between mt-5">
            <div className="flex items-center text-[#1D242D]">
              <p className="text-xs lg:text-sm pr-2 font-semibold">Payment Status </p>
              <SelectDropDown options={SelectedOption} onSelect={changePaymentStatus} />
            </div>
            <div className="flex items-center ml-6 text-[#1D242D]">
            <p className="text-xs lg:text-sm pr-2 font-semibold">Order Status</p>
            <SelectDropDown 
              onSelect={changeOrderStatus}
              options={[
                { label: "Pending", value: "1" },
                { label: "Shipped", value: "2" },
                { label: "Delivered", value: "3" },
              ]}
            />
            </div>
        </div>
        </div>
        <OrderTable 
          onRowClick={handleRowClick} 
          searchTerm={searchTerm} 
          data={data} 
          itemsPerPage={itemsPerPage} 
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isLoading={orders?.loading}
          totalRecord={totalRecord}
        />
        <OrderDrawer
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          id={selectedItem}
        />
      </div>
    </DashboardLayout>
  )
}

export default Orders